import axios from "axios"
import AppRouter from "../AppRouter"
import StoreAdapter from "../store/StoreAdapter"
import { Storage } from "../util"
import { ModulesEnum, TextEnum } from '../constants'
import RoutesEnum from '../constants/routesEnum'

const controller = "/usuario"

const UsuarioService = {
    login: async (username, password) => {
        let params = {
            username,
            password,
            grant_type: "password"
        }
        let body = []
        for (let property in params) {
            let encodedKey = encodeURIComponent(property)
            let encodedValue = encodeURIComponent(params[property])
            body.push(encodedKey + "=" + encodedValue)
        }
        body = body.join("&")
        const options = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Authorization": "Basic Y2xpZW50YXBwOjEyMzQ1"
            },
        }
        const { data } = await axios.post(`oauth/token`, body, options)
        if (data.access_token) {
            const usuario = {
                token: data.access_token,
                usu_id: data.id_usuario,
                usu_nombre: data.usu_nombre,
                usu_nombre_completo: data.usu_nombre_completo,
                pry_id: data.pry_id,
                usu_nivel: data.usu_nivel,
                roles: data.roles.split(","),
                usu_correo: data.usu_correo,
                pve_id: data.pve_id,
                cli_id: data.cli_id,
                opciones: data.opciones ? data.opciones.split(",") : null,
                modulo_grupos: data.modulo_grupos,
            }
            StoreAdapter.dispatch(StoreAdapter.modules.UsuarioStore.actions.setUsuario, usuario)
            return true
        } else {
            return false
        }
    },
    logout: () => {
        StoreAdapter.dispatch(StoreAdapter.modules.UsuarioStore.actions.removeUsuario)
        /**
         * para remover los datos del usuario del localstorage
         */
        Storage.remove(TextEnum.USUARIO)
        Storage.remove(TextEnum.ESTADOS)
        Storage.remove(TextEnum.TIPOS_PRODUCTO)
        Storage.remove(TextEnum.MARCAS)
        Storage.remove(TextEnum.UNIDADES_MEDIDA)
        Storage.remove(TextEnum.ALMACENES)
        Storage.remove(TextEnum.CATEGORIAS)
        Storage.remove(TextEnum.CONDICIONES_COMERCIALES)
        /**
         * para remover los datos como almacenes, estados, etc del localstorage
         */
        Storage.remove("data")
        AppRouter.push({
            name: RoutesEnum.Login.name
        })
    },
    cambiarContraseña: async (request) => {
        const { data } = await axios.post(`${controller}/changePassword`, request)
        return data
    },
    getUsuario: () => {
        return Storage.getObject("usuario")
    },
    verificarRoles: (...roles) => {
        let coincidences = 0
        UsuarioService.getUsuario().roles.forEach(rol1 => {
            roles.forEach(rol2 => {
                if (rol1 == rol2.rol_nombre) {
                    coincidences++
                }
            })
        })
        return coincidences != 0
    },
    registrar: async (usuario) => {
        const { data } = await axios.post(`${controller}/registrar`, {
            usuario
        })
        return data
    },
    obtener: async (usuario) => {
        const { data } = await axios.post(`${controller}/obtener`, {
            usuario
        })
        return data
    },
    remove: () => {
        StoreAdapter.dispatch(StoreAdapter.modules.UsuarioStore.actions.removeUsuario)
        Storage.remove("usuario")
    },
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    modificar: async (usuario) => {
        const { data } = await axios.post(`${controller}/modificar`, {
            usuario
        })
        return data
    },
    adjuntarFirma: async (request) => {
        let form = new FormData()
        form.append("firma", request.firma)
        form.append("usu_id", request.usu_id)
        const { data } = await axios.post(`${controller}/adjuntarFirma`, form)
        return data
    },
    isCoorporative: () => {
        return UsuarioService.getUsuario().usu_nivel == 1
    },
    getProject: () => {
        return UsuarioService.isCoorporative()
            ? null
            : UsuarioService.getUsuario().pry_id
    },
    obtenerOpciones: async () => {
        const request = {
            opcion_usuario: {
                usu_id: UsuarioService.getUsuario().usu_id
            }
        }
        const { data } = await axios.post(`${controller}/obtenerOpciones`, request)
        const opciones = data.data
        let usuario = Storage.getObject("usuario")
        if (opciones && usuario) {
            usuario.opciones = opciones.map(item => item.opc_id)
            Storage.setObject("usuario", usuario)
        }
    },
    removeData: () => {
        Storage.remove(TextEnum.USUARIO)
        Storage.remove(TextEnum.ESTADOS)
        Storage.remove(TextEnum.TIPOS_PRODUCTO)
        Storage.remove(TextEnum.MARCAS)
        Storage.remove(TextEnum.UNIDADES_MEDIDA)
        Storage.remove(TextEnum.ALMACENES)
        Storage.remove(TextEnum.CATEGORIAS)
        Storage.remove(TextEnum.CONDICIONES_COMERCIALES)
    }
}

export default UsuarioService